import { transformHump } from '$common/utils/string'
import languageUtils from '$common/utils/language';
// 国际化语言配置
// 项目语言包
//  从 navigator 里先获取语言
const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
const locale = navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : navigatorLanguage.indexOf('en') !== -1 ? 'en' : 'km';
// const locale = 'en';
export default {
  use: (Vue, VueI18n) => {
    Vue.use(VueI18n);
    //  初始化 i18n 对象
    const i18n = new VueI18n({
      locale, // 设置语言环境
      fallbackLocale: locale,
      messages: {},
      silentTranslationWarn: true // 禁止没匹配警告
    });
    const messages = {
      en: {
      },
      km: {
      },
      zh: {
      }
    };
    //  懒加载国家化
    const loadLanguageAsync = ({
      router, lang
    }) => {
      const __router = (router ?? i18n.router)?.replace(/_/g, '-');
      const __lang = lang ?? i18n.locale;
      //  如果缓存有，就不需要再重新去加载了
      if (messages[__lang][transformHump(__router)]) {
        i18n.setLocaleMessage(__lang, messages[__lang])
        return Promise.resolve(__lang)
      }
      if (__router && __lang) {
        //  对象里没有文案，则重新去拿
        return new Promise((resolve, reject) => import(`$legalPolicies/page/index/language/${__lang}/${__router}/${__router}`).then(resolve).catch(reject)).then(msgs => {
          //  整理成对应路由的对象
          const langJson = {};
          langJson[transformHump(__router)] = msgs.default || msgs;
          //  缓存文案到内存对象
          messages[__lang] = Object.assign({}, messages[__lang], langJson);
          //  保存当前路由
          i18n.router = __router;
          //  设置文案
          i18n.setLocaleMessage(__lang, messages[__lang])
          return __lang;
        }).catch(err => {
          return __lang;
        })
      }
      return new Promise((resolve, reject) => reject({}));
    }
    return {
      i18n,
      loadLanguageAsync
    };
  }
}
